module.exports = __webpack_public_path__ + "static/img/model-bg7.6ba954e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg7.jpg
// module id = gthN
// module chunks = 0